import * as R from "ramda";
export const NAMESPACE = "EventLightContactGroup";
export const TAB_INSTANCE_ID = "contact-group-tab";

export const TABS = {
  CONTACT_GROUP: "ContactGroupPage",
  EDIT: "Edit",
  CONTENT: "Files",
  HISTORY: "History"
};

export const TAB_IDS = [
  { id: TABS.CONTACT_GROUP, title: "Profile" },
  { id: TABS.EDIT, title: "Edit" }
  // { id: TABS.CONTENT, title: "Files" },
  // { id: TABS.HISTORY, title: "History" }
];

export const ABOUT_CARD_TEMPLATE = {
  salutation: "",
  first_name: "",
  last_name: "",
  honorific: "",
  title: "",
  company_name: "",
  email: ""
};

export const ABOUT_CARD_LABELS = id =>
  R.propOr("", id, {
    salutation: id,
    first_name: "first name",
    last_name: "last name",
    honorific: id,
    title: id,
    company_name: "company name",
    email: id
  });

export const APPLICATIONS_MOCK = {
  payload: {
    pagination: {
      page: "0",
      pageSize: "1",
      total: 11,
      pages: 11
    },
    applications: [
      {
        id: "996c312c-d57b-4590-a880-8f1c5c1cc6a2",
        slug: "new-application-form2312312321-12312123132123123312123",
        formId: "65d4e5ec-d714-4855-a5b4-b84645226f5c",
        status: "pending",
        name: "New Application Form2312312321 12312123132123123312123",
        open_label: "Pending",
        is_past_due: false
      }
    ]
  }
};
